import React from "react";
import { Box } from "@mui/material";
import HistoryDataGrid from "./alarm-history/HistoryDataGrid";

export default function AlarmHistory() {
  return (
    <Box>
      <HistoryDataGrid />
    </Box>
  );
}
